var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 35C60 37.75 57.75 40 55 40H5C2.25 40 0 37.75 0 35V5C0 2.25 2.25 0 5 0H55C57.75 0 60 2.25 60 5V35Z",
    fill: "#006FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2245 26L12.595 23.5724H8.44215L7.79477 26H4L8.1708 13H12.7782L17 26H13.2245ZM12 20.9985L11.3924 18.7094C11.2496 18.2014 11.0795 17.5446 10.8759 16.736C10.6739 15.9274 10.5403 15.3487 10.4749 15C10.4187 15.3246 10.3033 15.8582 10.1332 16.6022C9.96304 17.3462 9.58481 18.8131 9 21L12 20.9985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.738 25.9948L21.0443 16.6358H20.9634C21.0897 18.229 21.1521 19.4666 21.1521 20.3514V25.9934H18V13H22.7374L25.4865 22.226H25.5589L28.2512 13H33V25.9934H29.7286V20.2968C29.7286 20.0014 29.7343 19.6738 29.7428 19.3112C29.7513 18.9486 29.7925 18.0638 29.8649 16.654H29.784L27.1257 25.9948H23.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 25.9934H34V13H42V15.8182H37.6385V17.8622H41.6762V20.679H37.6385V23.1318H42V25.9934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0732 25.9934H52.0132L49.4778 21.9334L46.9732 25.9934H43L47.3092 19.3462L43.2562 13H47.1496L49.496 17.0166L51.7514 13H55.7596L51.645 19.6206L56.0732 25.9934Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAmex);
export default __webpack_public_path__ + "static/media/ico_amex.503f681b9701115d5eb45cbb20ad304f.svg";
export { ForwardRef as ReactComponent };